"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
var ClusterStatusSlice = function (_a) {
    var fill = _a.fill;
    return (react_1.default.createElement("path", { d: "\n        M 1 0\n        A 1 1 0 1 1 1 " + Math.sin(2 * Math.PI) + "\n        L 0 0\n    ", fill: fill }));
};
ClusterStatusSlice.displayName = 'ClusterStatusSlice';
var ClusterStatusContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  width: 0;\n  height: 0;\n  z-index: -1;\n\n  svg {\n    height: 30px !important;\n    width: 30px !important;\n  }\n"], ["\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  width: 0;\n  height: 0;\n  z-index: -1;\n\n  svg {\n    height: 30px !important;\n    width: 30px !important;\n  }\n"])));
ClusterStatusContainer.displayName = 'ClusterStatusContainer';
var ClusterStatus = function (props) {
    var _a = props.cluster, numberOfWarnings = _a.numberOfWarnings, numberOfAlerts = _a.numberOfAlerts;
    var showAlert = numberOfAlerts > 0;
    var showWarning = !showAlert && numberOfWarnings > 0;
    return (react_1.default.createElement(ClusterStatusContainer, null,
        react_1.default.createElement("svg", { viewBox: "-1 -1 2 2", style: { transform: 'rotate(-0.25turn)' } },
            showAlert && react_1.default.createElement(ClusterStatusSlice, { "data-test-id": 'alert-cluster-status', fill: dark_theme_1.default.colours.global.alarm }),
            showWarning && (react_1.default.createElement(ClusterStatusSlice, { "data-test-id": 'warning-cluster-status', fill: dark_theme_1.default.colours.global.warning })))));
};
ClusterStatus.displayName = 'ClusterStatus';
exports.default = ClusterStatus;
var templateObject_1;
